define('constants/colorConstants',[], function() {
    return Object.freeze({
        colorError300: "#e84c38",
        colorPrimary300: "#2696c6",
        colorPrimary600: "#0f3c4f",
        colorPrimaryWhite: "#ffffff",
        colorSecondaryCool200: "#808795",
        colorSecondaryWarm400: "#868686",
        colorSecondaryWarm600: "#454545",
        colorTertiaryGreen: "#389a60",
        colorTertiaryOrange: "#ffaf3d",
    });
});

